import React, { useState } from 'react';
import { validateTestEmail } from '../utils/validation';
import ActionButton from '../../../../shared/components/action-button/ActionButton';
import './TestEmailButton.css';

const TestEmailButton = ({ onSendTest, disabled }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setEmail('');
    setError('');
  };

  const handleSend = async () => {
    if (!validateTestEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    try {
      setSending(true);
      await onSendTest(email);
      handleClose();
    } catch (err) {
      setError('Failed to send test email');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <ActionButton type="button" onClick={handleOpen} disabled={disabled}>
        Send Test Email
      </ActionButton>

      {open && (
        <div className="email-test-modal" role="dialog" aria-modal="true" aria-label="Send test email">
          <div className="email-test-modal__backdrop" onClick={handleClose} />
          <div className="email-test-modal__panel">
            <div className="email-test-modal__header">
              <h3>Send Test Email</h3>
              <button type="button" className="email-test-modal__close" onClick={handleClose}>
                x
              </button>
            </div>

            {error && <div className="email-test-modal__error">{error}</div>}

            <label className="email-test-modal__field">
              <span>Email address</span>
              <input
                autoFocus
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="name@example.com"
              />
            </label>

            <div className="email-test-modal__actions">
              <button type="button" className="email-test-modal__button email-test-modal__button--secondary" onClick={handleClose}>
                Cancel
              </button>
              <button
                type="button"
                className="email-test-modal__button email-test-modal__button--primary"
                onClick={handleSend}
                disabled={sending}
              >
                {sending ? 'Sending...' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TestEmailButton; 